import React, { useState } from 'react';
import './Hero.css';
import { FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import logo from '../../assets/images/logo1.png'; 

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // Replace with your Web3Forms Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
      setTimeout(() => {
        setIsModalOpen(false);
        setResult("");
      }, 2000);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <motion.div 
          className="hero-text-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2 className="hero-sub">New Era.</h2>
          <h1 className="hero-main">NEW YOU.</h1>
          <h3 className="hero-tag">2 BHK Flats in Moshi</h3>
          
          <div className="hero-pills-vertical">
            <div className="pill">
              <div className="pill-icon"><FaMapMarkerAlt /></div>
              <span>MOSHI, PUNE</span>
            </div>
            <div className="pill">
              <div className="pill-icon"><FaPhoneAlt /></div>
              <span>9371320616</span>
            </div>
          </div>
        </motion.div>
      </div>

      <button className="vertical-enquire-bar" onClick={() => setIsModalOpen(true)}>
        <span className="v-text">ENQUIRE NOW</span>
        <div className="v-icon-circle">
          <FaArrowRight />
        </div>
      </button>

      <div className="floating-action-stack">
        <a href="tel:+919371320616" className="float-icon call-btn">
          <FaPhoneAlt />
        </a>
        <a href="https://wa.me/919371320616" className="float-icon whatsapp-btn" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp />
        </a>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsModalOpen(false)}>&times;</button>
            
            <div className="modal-header">
               <h2 className="enquire-title">Enquire Now</h2>
            </div>

            <form className="modal-form" onSubmit={onSubmit}>
              <input type="text" name="first_name" placeholder="First Name" required />
              <input type="text" name="last_name" placeholder="Last Name" required />
              <input type="email" name="email" placeholder="Email Id" required />
              <input type="tel" name="mobile" placeholder="Mobile No." required />
              
              {/* <select name="project" required className="modal-select"> */}
                {/* <option value="" disabled selected>Select Project</option>
                <option value="Sentosa Era">Sentosa Era</option> */}
                {/* Add more projects here */}
              {/* </select> */}

              <div className="checkbox-container">
                <input type="checkbox" id="consent" name="consent" required />
                <label htmlFor="consent">
                  I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                </label>
              </div>

              <button type="submit" className="modal-submit-btn">
                SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
              </button>
            </form>
            {result && <p className="form-status">{result}</p>}
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;